module.exports = __webpack_public_path__ + "img/model4.6972fef5.png";